// Setup event listeners for hovering over any of the top three navigation links
import anime from 'animejs/lib/anime.es.js';
const fadeOutTime = 300;
const mobileNavFadeInSpeed = 300;
const mobileNavContentFadeInSpeed = 300;
const mobileNavFadeOutSpeed = 400;
const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

window.addEventListener('DOMContentLoaded', () => {
    const videoBanner = document.querySelector('.videoBanner');
    const overlay = document.querySelector('.header__overlay');
    const primaryLinks = document.querySelectorAll('.nav__link--dropdown');
    const header = document.querySelector('header#header');
    const subnavLinks = header ? header.querySelectorAll('.nav__subnav-link') : null;

    if (primaryLinks) {
        primaryLinks.forEach(rootLink => {
            rootLink.addEventListener('mouseenter', e => { primaryLinkOnHover(e) });
        });
    }

    if (subnavLinks) {
        subnavLinks.forEach(subnavLink => {
            subnavLink.addEventListener('mouseenter', e => secondaryLinkOnHover(e));
            subnavLink.addEventListener('mouseleave', e => secondaryLinkOnExit(e));
        });
    }

    if (header) {
        header.addEventListener('mouseleave', e => { headerOnExit(e) });
    }

    // Mobile menu

    const mobileNavToggle = document.querySelector('#toggle-mobile-nav');
    if (mobileNavToggle) {
        mobileNavToggle.addEventListener("click", () => {
            openMobileNav(header);
        });
    }

    const mobileCloseNav = document.querySelector('#close-mobile-nav', '#close-story-modal');
    if (mobileCloseNav) {
        mobileCloseNav.addEventListener("click", () => {
            closeMobileNav(header);
        });
    }

    const primaryLinkOnHover = (event) => {
        if (event.target.parentNode.classList.contains('is-active')) return; // If link is already active we dont need to process further
        overlay.classList.add('header__overlay--open');

        // Handle removing all classes first
        primaryLinks.forEach(rootLink => {
            rootLink.parentNode.removeAttribute('should-show');
        });

        event.target.parentNode.setAttribute('should-show', 'true');

        primaryLinks.forEach(rootLink => {
            // If link has just been active we want to nicely animate it out
            if (rootLink.parentNode.classList.contains('is-active')) {
                rootLink.parentNode.classList.add('animating');
                rootLink.parentNode.style.zIndex = 150;

                // After X time we want to clean up the animation
                setTimeout(() => {
                    // If link should be shown we dont want to clean up as it could break currently shown link
                    if (rootLink.parentNode.getAttribute('should-show') != 'true') {
                        rootLink.parentNode.classList.remove('is-active');
                        rootLink.parentNode.style.zIndex = 1;
                    }
                    rootLink.parentNode.classList.remove('animating');
                }, 400);
            } else {
                rootLink.parentNode.classList.remove('is-active');
                rootLink.parentNode.style.zIndex = 1;
            }
        });

        // Set panel to show to higher zIndex to allow it to sit above remaining panels
        setTimeout(() => {
            event.target.parentNode.style.zIndex = 100;
        }, 420);

        event.target.parentNode.classList.add('is-active');

        header.classList.remove('header--transparent');
        if (header.classList.contains("header--white")) {

            header.classList.add('is-active', 'header--mobilenav-open', 'header--white', 'is-active--non-transparent')
        }
        else {
            header.classList.add('is-active', 'header--mobilenav-open', 'header--white')
        }

    };

    const secondaryLinkOnHover = (event) => {
        subnavLinks.forEach(subnavLink => {
            subnavLink.classList.add('nav__subnav-link--inactive');
        });

        event.target.classList.remove('nav__subnav-link--inactive');
    };

    const secondaryLinkOnExit = (event) => {
        subnavLinks.forEach(subnavLink => {
            subnavLink.classList.remove('nav__subnav-link--inactive');
        });
    };

    const headerOnExit = (event) => {
        primaryLinks.forEach(rootLink => {
            rootLink.parentNode.classList.remove('is-active');
        });

        if (shouldExitToTransparent()) {
            event.target.classList.add('header--transparent');
            event.target.classList.remove('is-active', 'header--mobilenav-open', 'header--white', 'is-active--non-transparent');
        }
        else {
            event.target.classList.add('header--white');
            event.target.classList.remove('is-active', 'header--mobilenav-open', 'header--transparent', 'is-active--non-transparent');
        }

        overlay.classList.remove('header__overlay--open');
    };

    // When closing menu should check whether it should swap to transparent background or white
    const shouldExitToTransparent = () => {
        if (videoBanner === null) return false;

        const videoBannerPosition = videoBanner.getBoundingClientRect();
        const scrollPos = window['scrolInstance'].scroll.instance.scroll.y;

        return ((scrollPos <= videoBannerPosition.bottom && scrollPos >= videoBannerPosition.top) || (window.scrollY < 50 && window.outerWidth < 992));
    }

    const closeMobileNav = (headerElement) => {
        const mobileNav = headerElement.querySelector('.header__mobile');

        let mobileNavCloseTimeline = anime.timeline({
            easing: 'linear',
        })

        mobileNavCloseTimeline
            .add({
                targets: mobileNav.querySelector('.header__mobile-content'),
                opacity: [1, 0],
                duration: mobileNavContentFadeInSpeed,
            })
            .add({
                targets: mobileNav,
                duration: mobileNavFadeOutSpeed,
                opacity: [1, 0],
            })

        mobileNavCloseTimeline.finished.then(() => {
            mobileNav.classList.remove('header__mobile--open');
            headerElement.classList.remove('header--mobilenav-open');
            document.body.classList.remove('overflow-hidden');
        });
    }

    const openMobileNav = (headerElement) => {
        const mobileNav = headerElement.querySelector('.header__mobile');
        mobileNav.classList.add('header__mobile--open');

        let mobileNavOpenTimeline = anime.timeline({
            easing: 'linear',
        })

        mobileNavOpenTimeline
            .add({
                targets: mobileNav,
                duration: mobileNavFadeInSpeed,
                opacity: 1,
                update: function (anim) {
                    if (Math.round(anim.progress) == 100) {
                    }
                }
            })
            .add({
                targets: mobileNav.querySelector('.header__mobile-content'),
                delay: 200,
                opacity: 1,
                duration: mobileNavContentFadeInSpeed,
            })

        mobileNavOpenTimeline.finished.then(() => {
            headerElement.classList.add('header--mobilenav-open');
            document.body.classList.add('overflow-hidden');
        });
    }
});

// Secondary header
const secondaryHeader = document.getElementById('secondary-header');
let secondaryHeaderExists = secondaryHeader ? true : false;
let secondaryHeaderVisible = false;

const secondaryHeaderStartingPoint = (window.innerHeight / 100) * 60;

let upTravel = 0;
const scrollMainNavOffset = 100;
let currentPositionY = 0;
let visibleMainNavOnScroll = false;


const toggleHeader = scrollY => {
    if (visibleMainNavOnScroll && upTravel == 0) {
        visibleMainNavOnScroll = false;
    }

    if (secondaryHeaderExists &&
        scrollY >= secondaryHeaderStartingPoint &&
        !visibleMainNavOnScroll &&
        !secondaryHeaderVisible && viewportWidth > 1024) {


        secondaryHeader.classList.add('header--visible');
        secondaryHeader.classList.remove('fade-out');
        secondaryHeader.classList.add('fade-in');
        header.classList.remove('fade-in');
        header.classList.add('fade-out');
        header.classList.remove('header--visible');

        secondaryHeaderVisible = true;
    }

    // hide sec
    if (secondaryHeaderExists &&
        scrollY < secondaryHeaderStartingPoint &&
        !visibleMainNavOnScroll &&
        secondaryHeaderVisible) {

        upTravel = 0;

        secondaryHeader.classList.remove('header--visible');
        header.classList.add('header--visible');

        if (!header.classList.contains("fade-in")) {
            header.classList.add("fade-in")
            header.classList.remove("fade-out")
        }

        secondaryHeaderVisible = false;
    }

    if (secondaryHeaderVisible && upTravel >= scrollMainNavOffset) {
        secondaryHeader.classList.remove('header--visible');
        header.classList.add('header--visible');
        secondaryHeader.classList.remove('fade-in');
        secondaryHeader.classList.add('fade-out');
        header.classList.remove('fade-out');
        header.classList.add('fade-in');

        secondaryHeaderVisible = false;
        visibleMainNavOnScroll = true;
    }
}

if (window['scrolInstance']) {
    window['scrolInstance'].on('scroll', args => {
        if (secondaryHeaderVisible || visibleMainNavOnScroll) {
            if (currentPositionY > args.scroll.y) {
                upTravel += Math.round(currentPositionY - args.scroll.y);
            } else {
                upTravel = 0;
            }
        }
        
        toggleHeader(args.scroll.y)
        currentPositionY = args.scroll.y;
    })
}